window.CalendarSelect = function () {
    var el = this;
    var rotateEL = false;
    var $rotateBalloon = $('#rotate-balloon');
    var defaultRotatePositions = {width: 6, height: 6};
    var rotatePositions = {};
    var defaultRemovePositions = {width: 6, height: 6};
    var removePositions = {};
    var defaultMoveImagePositions = {x: 0, y: 0, width: 64, height: 64};
    var moveImagePositions = {};
    var centerPositions = {};
    var positions = {};

    function initRotateBalloon() {
        var offset = {top: 0, left: 0};
        var pos = el._parent.svgRoot.getBoundingClientRect();
        var fixOffset = 70;

        offset.top += pos.top + $(window).scrollTop() - fixOffset;
        offset.left = pos.left + pos.width / 2 - $rotateBalloon.outerWidth() / 2;

        $rotateBalloon
                .removeClass('hide')
                .offset(offset)
                .text(parseInt(el.transform.getRotate(rotateEL).angle));
    }

    function hideRotateBalloon() {
        $rotateBalloon.addClass('hide');
    }

    function calculatePosSelection(element) {
        var pos = element.getBBox();
        var matrix = element.getCTM();
        var fixTextPosition = {y: 6};
        var countPoints = 9; // required number of points
        var points = [];
        var i;

        for (i = 0; i < countPoints; i++) {
            points[i] = el._parent.svgRoot.createSVGPoint();
        }

        points[0].x = pos.x;
        points[0].y = pos.y;
        points[1].x = pos.x + pos.width;
        points[1].y = pos.y;
        points[2].x = pos.x + pos.width;
        points[2].y = pos.y + pos.height;
        points[3].x = pos.x;
        points[3].y = pos.y + pos.height;
        points[4].x = pos.x;
        points[4].y = pos.y + pos.height / 2;
        points[5].x = pos.x + pos.width;
        points[5].y = pos.y + pos.height / 2;
        points[6].x = pos.x + pos.width / 2;
        points[6].y = pos.y;
        points[7].x = pos.x + pos.width / 2;
        points[7].y = pos.y + pos.height;
        points[8].x = pos.x + pos.width / 2;
        points[8].y = pos.y + pos.height / 2;

        if (el._parent.selectType === 'texts') {
            points[6].y -= fixTextPosition.y;
            points[7].y += fixTextPosition.y;
        }


        for (i = 0; i < countPoints; i++) {
            points[i] = points[i].matrixTransform(matrix);
        }

        positions = {
            x1: points[0].x,
            y1: points[0].y,
            x2: points[1].x,
            y2: points[1].y,
            x3: points[2].x,
            y3: points[2].y,
            x4: points[3].x,
            y4: points[3].y
        };

        rotatePositions.width = defaultRotatePositions.width / el.workarea.workAreaScale;
        rotatePositions.height = defaultRotatePositions.height / el.workarea.workAreaScale;
        rotatePositions.x = points[6].x - parseInt(rotatePositions.width / 2);
        rotatePositions.y = points[6].y - parseInt(rotatePositions.height / 2);

        removePositions.width = defaultRemovePositions.width / el.workarea.workAreaScale;
        removePositions.height = defaultRemovePositions.height / el.workarea.workAreaScale;
        removePositions.x = points[7].x - parseInt(removePositions.width / 2);
        removePositions.y = points[7].y - parseInt(removePositions.height / 2);

        moveImagePositions.width = defaultMoveImagePositions.width / el.workarea.workAreaScale;
        moveImagePositions.height = defaultMoveImagePositions.height / el.workarea.workAreaScale;
        moveImagePositions.x = points[8].x - parseInt(moveImagePositions.width / 2);
        moveImagePositions.y = points[8].y - parseInt(moveImagePositions.height / 2);

        centerPositions.x = pos.x + parseInt(pos.width / 2);
        centerPositions.y = pos.y + parseInt(pos.height / 2);
    }

    el.update = function (element) {
        calculatePosSelection(element);

        $("#workarea").attr('points', positions.x1 + ',' + positions.y1 + ' ' + positions.x2 + ',' + positions.y2 + ' ' + positions.x3 + ',' + positions.y3 + ' ' + positions.x4 + ',' + positions.y4 + ' ' + positions.x1 + ',' + positions.y1);

        if (el._parent.selectType !== 'texts') {
            $("#workarea-border-1").attr('x1', positions.x1).attr('y1', positions.y1).attr('x2', positions.x2).attr('y2', positions.y2);
            $("#workarea-border-2").attr('x1', positions.x2).attr('y1', positions.y2).attr('x2', positions.x3).attr('y2', positions.y3);
            $("#workarea-border-3").attr('x1', positions.x3).attr('y1', positions.y3).attr('x2', positions.x4).attr('y2', positions.y4);
            $("#workarea-border-4").attr('x1', positions.x4).attr('y1', positions.y4).attr('x2', positions.x1).attr('y2', positions.y1);
        }

        if (el._parent.selectType === 'texts') {
            $("#rotate-btn").attr('x', rotatePositions.x).attr('y', rotatePositions.y);
            $("#delete-btn").attr('x', removePositions.x).attr('y', removePositions.y);
            initRotateBalloon();
        }
    };

    el.show = function (element, type, updatePanel) {
        updatePanel = updatePanel === undefined ? true : updatePanel;
        el._parent.selectType = type;
        el._parent.selectId = element.getAttribute('data-id');
        el._parent.svgRoot = document.getElementById('calendar-number');

        var bg = false;
        switch (type) {
            case 'backgrounds':
                bg = el._parent.svgRoot.getElementById('backgrounds-item-' + el._parent.selectId);
                break;
            case 'texts':
                bg = el._parent.svgRoot.getElementById('text-item-' + el._parent.selectId);
                break;
        }

        calculatePosSelection(bg);

        var data = {
            positions: positions,
            rotatePositions: rotatePositions,
            removePositions: removePositions,
            moveImagePositions: moveImagePositions,
            isExistText: el._parent.selectType === 'texts',
            isExistBackgrounds: el._parent.selectType === 'backgrounds',
        };

        var output = window.Mustache.render($('#calendar-selection-template').html(), data);
        el.calendarGrid.renderSelectedNumber(output);

        if (updatePanel) {
            el.panel(type);
        }

        el._parent.svgRoot = document.getElementById('calendar-number');

        if (type === 'texts') {
            rotateEL = el._parent.svgRoot.getElementById('text-item-' + el._parent.selectId);
            initRotateBalloon();
            el.calendarText.init();
        }
    };

    el.panel = function(type) {
        var templateData = {};

        templateData[type] = true;

        var panelHtml = el.templater.render($('#calendar-selection-panel-template').html(), templateData);
        $('.calendar-control-panel').addClass('hide');
        $('#calendar-selection-panel').html(panelHtml).removeClass('hide');
    };

    el.hide = function () {
        $('.calendar-control-panel').addClass('hide');
        $('#calendar-main-panel').removeClass('hide');
        el.calendarGrid.renderSelectedNumber();
        el._parent.svgRoot = false;
        hideRotateBalloon();
    };

    el.check = function (event) {
        var selection = document.getElementsByClassName('calendar-selection');
        var panel = $(event.target).parents('#calendar-selection-panel');
        var coord = $(event.target).parents('#coord-balloon');

        if (selection.length > 0 && event.target.namespaceURI !== 'http://www.w3.org/2000/svg' && panel.length === 0 && coord.length === 0) {
            el.hide();
        }
    };

    $('body').on('mousedown touchstart', el.check);

    $(document).on('click', '.js-calendar-select-show', function() {
        el.show(this, $(this).attr('data-type'));
    });
};